/*
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-05-21 16:02:42
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-09-04 15:16:38
 * @FilePath: \qctsw-vue\packages\app\src\composables\useWater.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export interface WaterMark {
  set: (str: string, parentNode?: HTMLElement) => void
}
let timeKey: any
const watermark: WaterMark = {
  set: (str: string, parentNode?: HTMLElement) => {
    let id = setWatermark(str, parentNode)
    timeKey = setInterval(() => {
      if (document.getElementById(id) === null) {
        clearInterval(timeKey)
        id = setWatermark(str, parentNode)
      }
      else {
        clearInterval(timeKey)
      }
    }, 2000)
    window.onresize = () => {
      setWatermark(str, parentNode)
    }
  },
}

function setWatermark(str: string, parentNode?: HTMLElement) {
  const id = '1.23452384164.123412415'

  if (document.getElementById(id) !== null) {
    const node = document.getElementById(id)
    if (node?.parentNode)
      node.parentNode.removeChild(node)
  }

  const can = document.createElement('canvas')
  can.width = 172
  can.height = 60

  const cans = can.getContext('2d')!
  cans.rotate(-20 * Math.PI / 180)
  cans.font = '25px Vedana'
  cans.fillStyle = 'rgba(0, 0, 0, 0.08)'
  cans.textAlign = 'left'
  cans.textBaseline = 'middle'
  cans.fillText(str, can.width / 20, can.height)

  const div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '1px'
  div.style.position = 'absolute'
  div.style.zIndex = '900'
  div.style.width = '100%'
  div.style.height = '100%'
  div.style.background = `url(${can.toDataURL('image/png')}) left top repeat`
  if (parentNode)
    parentNode?.appendChild(div)
  else
    document.body.appendChild(div)

  return id
}

export default watermark
